import DataExtractionService from '../../dataExtraction/DataExtractionService';
import UrlService from '../../UrlService';

import { createCRMMessageHandler } from './crmMessageHandler';

export const salesforceLightningMessageHandler = createCRMMessageHandler({
  isCompanyPage: UrlService.isSalesforceLightningAccountPage,
  isContactPage: UrlService.isSalesforceLightningContactPage,
  isLeadPage: UrlService.isSalesforceLightningLeadPage,
  extractionService: DataExtractionService.salesforceLightning,
});
